import DOMPurify from 'dompurify';
import {VideoParagraph } from './VideoParagraph';

export const TextParagraph = ({ paragraph }) => {
  
  const chooseRenderer = (j, block) => {
    if (block.src.includes("/video.html")){
      return <VideoParagraph key={j} paragraph={block.src} /> 
    }

    return block.src.includes('<') ? (
      <div 
        key={j} 
        className={block.class}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(block.src) }}
      />
    ) : (
      <div key={j} className={block.class}>
        {block.src}
      </div>
    )
  }
  
  return (<div className="col-12 mb-3">
    {paragraph.blocks.map((block, j) => 
      chooseRenderer(j, block)
    )}
  </div>
)}; 